import React from 'react';
import { ArrowLeft } from 'lucide-react';
export function TermsPage() {
  return <div className="min-h-screen w-full bg-[#FAF8F5] font-sans text-[#3A3A3A]" data-id="element-342">
      <div className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-343">
        {/* Back Link */}
        <a href="/" className="inline-flex items-center gap-2 text-[#2D4A3E] hover:text-[#2D4A3E]/80 transition-colors mb-8" data-id="element-344">
          <ArrowLeft className="w-4 h-4" data-id="element-345" />
          <span className="text-sm font-medium" data-id="element-346">Back to Home</span>
        </a>

        {/* Header */}
        <header className="mb-12" data-id="element-347">
          <h1 className="font-['DM_Sans'] text-4xl md:text-5xl font-medium text-[#3A3A3A] mb-4" data-id="element-348">
            Terms of Service
          </h1>
          <p className="text-[#B8A99A] text-sm" data-id="element-349">Last updated: January 2026</p>
        </header>

        {/* Content */}
        <article className="prose prose-lg max-w-none" data-id="element-350">
          <p className="text-lg text-[#3A3A3A]/80 leading-relaxed mb-8" data-id="element-351">
            By using Cardkeeper (the "App" or "Service"), you agree to these
            Terms of Service.
          </p>

          <Section title="Use of the App" data-id="element-352">
            <p data-id="element-353">
              Cardkeeper allows you to scan and organize greeting cards and
              related information for personal use. You agree to use the app
              only for lawful purposes.
            </p>
          </Section>

          <Section title="Accounts and Access" data-id="element-354">
            <ul data-id="element-355">
              <li data-id="element-356">The app may be used without creating an account.</li>
              <li data-id="element-357">
                Optional email submission is used only for communication and
                updates.
              </li>
              <li data-id="element-358">
                You are responsible for maintaining access to your device and
                data.
              </li>
            </ul>
          </Section>

          <Section title="Subscriptions and Payments" data-id="element-359">
            <ul data-id="element-360">
              <li data-id="element-361">
                Cardkeeper may offer paid subscriptions through Apple's In-App
                Purchase system.
              </li>
              <li data-id="element-362">Payments are handled by Apple, and their terms apply.</li>
              <li data-id="element-363">
                Subscription features are available only while your subscription
                is active.
              </li>
            </ul>
          </Section>

          <Section title="Data and Content" data-id="element-364">
            <ul data-id="element-365">
              <li data-id="element-366">You retain ownership of any content you add to the app.</li>
              <li data-id="element-367">
                In the current version, content is stored locally on your
                device.
              </li>
              <li data-id="element-368">
                We are not responsible for data loss due to device issues,
                deletion, or backups.
              </li>
            </ul>
          </Section>

          <Section title="Intellectual Property" data-id="element-369">
            <p data-id="element-370">
              The app, design, and branding are owned by Cardkeeper. You may not
              copy, modify, or distribute the app without permission.
            </p>
          </Section>

          <Section title="Disclaimer" data-id="element-371">
            <p data-id="element-372">
              The app is provided "as is" without warranties of any kind. We do
              not guarantee uninterrupted or error-free operation.
            </p>
          </Section>

          <Section title="Limitation of Liability" data-id="element-373">
            <p data-id="element-374">
              To the fullest extent permitted by law, Cardkeeper is not liable
              for any damages resulting from use of the app.
            </p>
          </Section>

          <Section title="Changes to These Terms" data-id="element-375">
            <p data-id="element-376">
              We may update these Terms from time to time. Continued use of the
              app means you accept the updated terms.
            </p>
          </Section>

          <Section title="Contact" data-id="element-377">
            <p data-id="element-378">
              Questions about these Terms can be sent to:{' '}
              <a href="mailto:support@cardkeeperapp.com" className="text-[#2D4A3E] hover:underline" data-id="element-379">
                support@cardkeeperapp.com
              </a>
            </p>
          </Section>
        </article>
      </div>
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section className="mb-10" data-id="element-380">
      <h2 className="font-['DM_Sans'] text-2xl font-medium text-[#3A3A3A] mb-4 pb-2 border-b border-[#B8A99A]/20" data-id="element-381">
        {title}
      </h2>
      <div className="text-[#3A3A3A]/80 leading-relaxed space-y-4 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1" data-id="element-382">
        {children}
      </div>
    </section>;
}